module.exports = __webpack_public_path__ + "static/media/news-2.000fef59.jpeg";